import React from 'react';
import {
  Box
} from '@mui/material';
import { ImageResolutionsInterface } from '@kimuno/api-sdk/lib/types/responses/Common';
import SelectablePage from './SelectablePage';
import { spaces } from '../../assets/styles/themes/tokens';

interface MindItemPageSelectionDialogContent {
  handlePageClick: (index: number) => void;
  mindItemPages: ImageResolutionsInterface[];
  selectedPages: number[];
}

const MindItemPageSelectionDialogContent = (props: MindItemPageSelectionDialogContent) => {
  const {
    handlePageClick,
    mindItemPages,
    selectedPages,
  } = props;

  return (
    <Box sx={{
      width: '100%',
      display: 'inline-flex',
      position: 'relative',
    }}>
      {
        mindItemPages.map((page, index) => {           
          return <SelectablePage
            key={index}
            page={page}
            index={index}
            handlePageClick={handlePageClick}
            isPageSelected={selectedPages.includes(index)}
            marginRight={index === mindItemPages.length - 1 ? '0px' : spaces.xs}
          />;
        })
      }
    </Box>
  );
};

export default MindItemPageSelectionDialogContent;
